/* buybox dele (variant-radios/product-swatches/product-form do Dawn customizado) em vanilla, sobre as NOSSAS variantes.
   Band + Cup (ou Size) -> variante (Size = banda+taca) da cor do produto da rota; o input hidden `id` do form dele e o
   preco do ATC acompanham. Amostra de cor = outro produto (navega). Tecido alterna o grupo de cores visivel.
   Miniatura -> slide da galeria (cl-sw.js). Sticky ATC envia o mesmo form. */
(function(){
  function boot(){
    document.querySelectorAll('.cl-pdp').forEach(function(root){
      if (root.__clPdp) return; root.__clPdp = 1;
      var vs = [], names = [];
      try { vs = JSON.parse(root.querySelector('script[data-cl-variants]').textContent); names = JSON.parse(root.querySelector('script[data-cl-opts]').textContent); } catch(e){}
      var form = root.querySelector('#product-form-cl-pdp'); if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var sizeIdx = names.findIndex(function(n){ return /size|größe/i.test(n); });
      var cur = vs.find(function(v){ return String(v.id) === idInput.value; }) || vs[0];
      var bands = root.querySelectorAll('input[data-cl-opt="0"]'), cups = root.querySelectorAll('input[data-cl-opt="1"]');
      var bc = cups.length > 0;
      function sel(list){ var x = Array.prototype.find.call(list, function(i){ return i.checked; }); return x ? x.value : null; }
      function match(size){
        return vs.find(function(v){ return v.o.every(function(o, k){ return k === sizeIdx ? o === size : (!cur || o === cur.o[k]); }); });
      }
      function prices(t){ root.querySelectorAll('.igPrice.price-item--regular, .button-price .price-a-b-control').forEach(function(e){ e.textContent = t; }); }
      function avail(){
        // marca as opcoes sem variante disponivel (classe disabled do dele)
        var b = sel(bands);
        (bc ? cups : bands).forEach(function(inp){
          var size = bc ? (b ? b + inp.value : null) : inp.value;
          var ok = size ? !!(match(size) || {}).a : vs.some(function(v){ return v.a && (v.o[sizeIdx] || '').slice(-inp.value.length) === inp.value; });
          inp.classList.toggle('disabled', !ok);
        });
      }
      function update(){
        var b = sel(bands), c = bc ? sel(cups) : '';
        var s0 = root.querySelector('[data-cl-sel="0"]'), s1 = root.querySelector('[data-cl-sel="1"]');
        if (s0) s0.textContent = b || ''; if (s1) s1.textContent = c || '';
        avail();
        if (!b || (bc && !c)) return;
        var v = match(bc ? b + c : b);
        var btn = form.querySelector('.atc-wrapper.ab-control .product-form__submit') || form.querySelector('.product-form__submit');
        if (!v) { if (btn) btn.setAttribute('disabled', 'disabled'); return; }
        idInput.value = v.id; prices(v.p);
        if (btn) { if (v.a) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', 'disabled');
          var t = btn.querySelector('[data-add-to-cart-text]'); if (t) t.textContent = v.a ? 'Add to cart' : 'Sold out'; }
        var err = root.querySelector('.product-form__error-message-wrapper'); if (err) err.hidden = true;
      }
      bands.forEach(function(i){ i.addEventListener('change', update); });
      cups.forEach(function(i){ i.addEventListener('change', update); });
      avail();
      form.__clValidate = function(){
        var need = sizeIdx >= 0 && bands.length && (!sel(bands) || (bc && !sel(cups)));
        if (!need) return true;
        var err = root.querySelector('.product-form__error-message-wrapper'), m = root.querySelector('.product-form__error-message');
        if (m) m.textContent = bc ? 'Please select a band and cup size' : 'Please select a size';
        if (err) err.hidden = false;
        return false;
      };
      form.addEventListener('submit', function(e){ if (!form.__clValidate()) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
      // amostras de cor: cada cor e outro produto
      root.querySelectorAll('input[data-cl-href]').forEach(function(i){
        i.addEventListener('change', function(){ var h = i.getAttribute('data-cl-href'); if (h && location.pathname !== h) location.href = h; });
      });
      // tecido
      root.querySelectorAll('.fabric-option').forEach(function(b){
        b.addEventListener('click', function(){
          var f = b.getAttribute('data-fabric');
          root.querySelectorAll('.fabric-option').forEach(function(x){ x.classList.toggle('active', x === b); });
          root.querySelectorAll('fieldset.fabric-treatment').forEach(function(fs){ var on = fs.getAttribute('data-fabric') === f; fs.setAttribute('data-active-fabric', on ? 'true' : 'false'); fs.classList.toggle('is-hidden-fabric', !on); });
        });
      });
      // miniaturas -> slide
      root.querySelectorAll('.product-thumbnail-image').forEach(function(t){
        t.addEventListener('click', function(){
          var i = parseInt(t.getAttribute('data-index'), 10) || 0, sw = root.querySelector('.ce-swiper-container.product-images');
          if (sw && sw.clSwGo) sw.clSwGo(i);
          root.querySelectorAll('.product-thumbnail-image').forEach(function(x){ if (x === t) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
        });
      });
      // sticky ATC: aparece quando o ATC principal sai da tela por cima (classe invisible do dele)
      var st = root.querySelector('.ce-sticky-add-to-cart'), atc = form.querySelector('.product-form__buttons');
      if (st && atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function(es){ es.forEach(function(e){ st.classList.toggle('invisible', e.isIntersecting || e.boundingClientRect.top > 0); }); }).observe(atc);
      }
      // sticky ATC
      root.querySelectorAll('.ce-sticky-add-to-cart a.button').forEach(function(a){
        a.addEventListener('click', function(e){ e.preventDefault(); if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* <custom-accordion> dele (custom-accordion.js) em vanilla: clique no .accordion-heading abre/fecha o .accordion_item
   (classe active + altura medida do conteudo + opacity 1 + item-margin-top); data-allow-multiple-open="false" fecha os
   irmaos. */
(function(){
  function open(row){ row.classList.add('active'); var w = row.querySelector('.accordion-more'), c = row.querySelector('.accordion-more > div');
    if (!w) return; w.style.setProperty('height', (c ? c.offsetHeight : 0) + 'px'); w.style.setProperty('opacity', '1'); w.classList.add('item-margin-top');
    var h = row.querySelector('.accordion-heading'); if (h) h.setAttribute('aria-expanded', 'true'); }
  function close(row){ row.classList.remove('active'); var w = row.querySelector('.accordion-more');
    if (!w) return; w.style.removeProperty('height'); w.style.setProperty('opacity', '0'); w.classList.remove('item-margin-top');
    var h = row.querySelector('.accordion-heading'); if (h) h.setAttribute('aria-expanded', 'false'); }
  function boot(){
    document.querySelectorAll('.ce-custom-accordion').forEach(function(acc){
      if (acc.__clAcc) return; acc.__clAcc = 1;
      var rows = acc.querySelectorAll('.accordion_item');
      acc.querySelectorAll('.accordion-heading').forEach(function(t){
        t.addEventListener('click', function(e){
          var row = e.target.closest('.accordion_item'); if (!row) return;
          if (row.classList.contains('active')) { close(row); return; }
          if (acc.getAttribute('data-allow-multiple-open') === 'false') rows.forEach(close);
          open(row);
        });
        t.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); } });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
